module.exports = __webpack_public_path__ + "static/img/我的@3x.9be5f3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/bottom/我的@3x.png
// module id = 1239
// module chunks = 358